<template>
    <div class="push-notifications-container shadow-sm">
        <div class="modal fade" id="editPushNotificationModal" tabindex="-1" aria-labelledby="editPushNotificationModal" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content"  v-if="this.editedPushNotification != null">
                    <div class="modal-header">
                        <h5 class="modal-title" v-if="this.editedPushNotification != null && this.editedPushNotification.id != null">{{ $t("admin.push_notifications.edit_dialog.edit_title") }}</h5>
                        <h5 class="modal-title" v-if="this.editedPushNotification != null && this.editedPushNotification.id == null">{{ $t("admin.push_notifications.edit_dialog.new_title") }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <h5>{{ $t("admin.push_notifications.edit_dialog.title_label") }}</h5>
                        <div class="mb-3">
                            <label for="title_english" class="form-label">{{ $t("admin.push_notifications.edit_dialog.english_label") }}</label>
                            <input type="text" class="form-control" id="title_english" v-model="editedPushNotification.title.en">
                        </div>
                        <div class="mb-3">
                            <label for="title_french" class="form-label">{{ $t("admin.push_notifications.edit_dialog.french_label") }}</label>
                            <input type="text" class="form-control" id="title_french" v-model="editedPushNotification.title.fr">
                        </div>

                        <h5>{{ $t("admin.push_notifications.edit_dialog.message_label") }}</h5>
                        <div class="mb-3">
                            <label for="message_english" class="form-label">{{ $t("admin.push_notifications.edit_dialog.english_label") }}</label>
                            <textarea class="form-control" id="message_english" v-model="editedPushNotification.message.en"></textarea>
                        </div>
                        <div class="mb-3">
                            <label for="message_french" class="form-label">{{ $t("admin.push_notifications.edit_dialog.french_label") }}</label>
                            <textarea type="text" class="form-control" id="message_french" v-model="editedPushNotification.message.fr"></textarea>
                        </div>

                        <!--<h5>{{ $t("admin.push_notifications.edit_dialog.parameters_label") }}</h5>
                        <div class="mb-3">
                            <label for="scheduledOn" class="form-label">{{ $t("admin.push_notifications.edit_dialog.scheduled_on_label") }}</label>
                            <DateSelector class="form-control start-date-input" id="scheduledOn" v-model="editedPushNotificationScheduledOn" mode="dateTime"></DateSelector>
                        </div>-->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" v-on:click="handleCloseEditedPushNotificationClicked()" >{{ $t("admin.push_notifications.edit_dialog.close_button") }}</button>
                        <!--<button type="button" class="btn btn-secondary" v-on:click="handleSendTestEditedPushNotificationClicked()">{{ $t("admin.push_notifications.edit_dialog.send_test_button") }}</button>-->
                        <button type="button" class="btn btn-primary" v-on:click="handleSaveAsDraftEditedPushNotificationClicked()">{{ $t("admin.push_notifications.edit_dialog.save_as_draft_button") }}</button>
                        <button type="button" class="btn btn-primary" v-on:click="handleSaveNowEditedPushNotificationClicked()">{{ $t("admin.push_notifications.edit_dialog.save_and_send_now_button") }}</button>
                        <!--<button type="button" class="btn btn-primary" v-on:click="handleSaveAndScheduleEditedPushNotificationClicked()">{{ $t("admin.push_notifications.edit_dialog.save_and_schedule_button") }}</button>-->
                    </div>
                </div>
            </div>
        </div>

        <YesNoAlert ref="confirmDeleteAlert" id="confirmDeleteAlert" v-bind:title="$t('admin.push_notifications.confirm_delete_title')" v-bind:message="$t('admin.push_notifications.confirm_delete_message')" v-on:yes="handleDeletePushNotificationConfirmed()" />
        <YesNoAlert ref="confirmSendTestAlert" id="confirmSendTestAlert" v-bind:title="$t('admin.push_notifications.confirm_send_test_title')" v-bind:message="$t('admin.push_notifications.confirm_send_test_message', { email: this.$store.state.currentUser.email })" v-on:yes="handleSendTestPushNotificationConfirmed()" />
        <YesNoAlert ref="confirmSendNowAlert" id="confirmSendNowAlert" v-bind:title="$t('admin.push_notifications.confirm_send_now_title')" v-bind:message="$t('admin.push_notifications.confirm_send_now_message')" v-on:yes="handleSendNowPushNotificationConfirmed()" />

        <div class="toolbar">
            <button class="btn btn-primary btn-sm" v-on:click="handleNewPushNotificationClicked()">{{ $t("admin.push_notifications.new_button") }}</button>
        </div>

        <ul class="push-notifications-list">
            <li class="push-notification-container header">
                <div class="push-notification-title header">{{ $t("admin.push_notifications.message_header") }}</div>
                <div class="push-notification-status header">{{ $t("admin.push_notifications.status_header") }}</div>
                <div class="push-notification-actions header">{{ $t("admin.push_notifications.actions_header") }}</div>
                <div class="push-notification-last-modified header">{{ $t("admin.push_notifications.last_updated_on_header") }}</div>
            </li>
        </ul>
        <div v-if="!pushNotifications || pushNotifications.length == 0" class="empty-list">{{ $t("admin.push_notifications.no_notifications_label") }}</div>
        <div class="push-notifications-list-container">
            <ul class="push-notifications-list scrolling-area">
                <li class="push-notification-container" v-for="pushNotification of pushNotifications" v-bind:key="pushNotification.id">
                    <div class="push-notification-status">
                        <span v-if="pushNotification.status == 'draft'" class="badge bg-info">{{ $t("admin.push_notifications.draft_badge") }}</span>
                        <span v-if="pushNotification.status == 'scheduled' || pushNotification.status == 'to_schedule'" class="badge bg-primary">{{ $t("admin.push_notifications.scheduled_badge") }}</span>
                        <span v-if="pushNotification.status == 'sent'" class="badge bg-success">{{ $t("admin.push_notifications.sent_badge") }}</span>
                    </div>
                    <div class="push-notification-title">{{ pushNotificationTitle(pushNotification) }}</div>
                    <div class="push-notification-message">{{ pushNotificationMessage(pushNotification) }}</div>
                    <div class="push-notification-parameters">{{ pushNotificationParameters(pushNotification) }}</div>
                    <div class="push-notification-actions">
                        <button v-if="pushNotification.status == 'scheduled' || pushNotification.status == 'to_schedule'" class="btn btn-info btn-sm" v-on:click="handleMarkAsDraftButtonClicked(pushNotification)">{{ $t("admin.push_notifications.mark_as_draft_button") }}</button>
                        <button v-if="pushNotification.status == 'draft'" class="btn btn-primary btn-sm" v-on:click="handleEditPushNotificationClicked(pushNotification)">{{ $t("admin.push_notifications.edit_button") }}</button>
                        <button class="btn btn-danger btn-sm" v-on:click="handleDeletePushNotificationClicked(pushNotification)">{{ $t("admin.push_notifications.delete_button") }}</button>
                        <!--<button v-if="pushNotification.status != 'sent'" class="btn btn-primary btn-sm" v-on:click="handleSendTestButtonClicked(pushNotification)">{{ $t("admin.push_notifications.send_test_button") }}</button>
                        <button v-if="pushNotification.status == 'draft' && pushNotification.scheduledOn" class="btn btn-primary btn-sm" v-on:click="handleScheduleButtonClicked(pushNotification)">{{ $t("admin.push_notifications.schedule_button") }}</button>-->
                        <button v-if="pushNotification.status == 'draft'" class="btn btn-primary btn-sm" v-on:click="handleSendNowButtonClicked(pushNotification)">{{ $t("admin.push_notifications.send_now_button") }}</button>
                    </div>
                    <div class="message-last-updated-on">{{ pushNotificationLastUpdatedOn(pushNotification) }}</div>
                    <hr />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
//import DateSelector from "@/views/ui/dateselector/DateSelector.vue"
import MessagingService from "@/service/MessagingService.js";
import MapService from "@/service/MapService.js";
import PushNotification from "@/model/PushNotification.js";
import LangUtils from '@/utils/LangUtils';
import DateUtils from '@/utils/DateUtils';
import YesNoAlert from "@/views/ui/alert/YesNoAlert"
import * as moment from 'moment';

export default {
    name: "OpeningMessagesEditor",

    components: {
//        DateSelector,
        YesNoAlert
    },

    data() {
        return {
            messagingService: new MessagingService(),
            mapService: new MapService(),
            pushNotifications: null,
            editedPushNotification: null,
            editionModal: null,
            pushNotificationToDelete: null,
            pushNotificationToSendTest: null,
            pushNotificationToSendNow: null
        }
    },

    props: {
        publisherId: String,
        mapId: String
    },

    computed: {
        editedPushNotificationScheduledOn: {
            get: function() {
                return this.editedPushNotification.scheduledOn ? DateUtils.formatForDateTimeInput(new Date(this.editedPushNotification.scheduledOn)) : null;
            },

            set: function(newValue) {
                if (this.editedPushNotification) {
                    this.editedPushNotification.scheduledOn = newValue != null ? Date.parse(newValue) : null;
                }

                if (this.editedPushNotification.scheduledOn == null) {
                    this.$forceUpdate();
                }
            }
        }
    },

    watch: {
        editedPushNotification: function() {
            if (this.editedPushNotification != null) {
                this.editionModal.show();
            } else {
                this.editionModal.hide();
            }
        }
    },

    methods: {
        loadPushNotifications() {
            this.messagingService.loadPushNotificationsForMap(this.publisherId, this.mapId).then((pushNotifications) => {
                this.pushNotifications = pushNotifications;
            }).catch((error) => {
                console.log(error);
            });
        },

        savePushNotification(pushNotification, sendTest = false, sendNow = false) {
            pushNotification.lastUpdate = new Date().getTime();

            if (sendTest) {
                pushNotification.testTo = "user:" + this.$store.state.currentUser.uid;
            }

            if (sendNow) {
                this.editedPushNotification = null;
                pushNotification.scheduledOn = new Date().getTime();
                pushNotification.status = "sent";
                this.messagingService.savePushNotificationForPublisher(this.publisherId, pushNotification).then(() => {
                    this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                        if (map && map.bundleIds) {
                            for (const bundleId in map.bundleIds) {
                                if (map.bundleIds[bundleId] == true) {
                                    this.messagingService.sendPushNotificationForMap(this.publisherId, this.$store.state.currentPublisher.name, bundleId, this.mapId, pushNotification).then(() => {
                                        this.pushNotificationToDelete = null;
                                        this.pushNotificationToSendTest = null;
                                        this.pushNotificationToSendNow = null;
                                        this.loadPushNotifications();
                                    }).catch((error) => {
                                        console.log(error);
                                    });
                                }
                            }
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                }).catch((error) => {
                    console.log("failed");
                    console.log(error);
                });
            } else {
                this.messagingService.savePushNotificationForPublisher(this.publisherId, pushNotification).then(() => {
                    this.editedPushNotification = null;
                    this.pushNotificationToDelete = null;
                    this.pushNotificationToSendTest = null;
                    this.pushNotificationToSendNow = null;
                    this.loadPushNotifications();
                }).catch((error) => {
                    console.log(error);
                });
            }
        },

        deletePushNotification(pushNotification) {
            this.messagingService.deletePushNotificationForPublisher(this.$store.state.currentPublisher.id, pushNotification.id).then(() => {
                this.loadPushNotifications();
            }).catch((error) => {
                console.log(error);
            });
        },

        pushNotificationTitle(pushNotification) {
            return LangUtils.valueForLanguage(pushNotification.title, this.$i18n.locale);
        },

        pushNotificationMessage(pushNotification) {
            return LangUtils.valueForLanguage(pushNotification.message, this.$i18n.locale);
        },

        pushNotificationParameters(pushNotification) {
            var parametersString = "";

            if (pushNotification.scheduledOn) {
                if (pushNotification.status == "scheduled" || pushNotification.status == "to_schedule") {
                    parametersString = this.$t("admin.push_notifications.scheduled_on_label") + " " + moment(new Date(pushNotification.scheduledOn)).format("YYYY-MM-DD hh:mm");
                } else if (pushNotification.status == "sent") {
                    parametersString = this.$t("admin.push_notifications.sent_on_label") + " " + moment(new Date(pushNotification.scheduledOn)).format("YYYY-MM-DD hh:mm");
                } else {
                    parametersString = this.$t("admin.push_notifications.planned_scheduled_date_label") + " " + moment(new Date(pushNotification.scheduledOn)).format("YYYY-MM-DD hh:mm");
                }
            } else {
                parametersString = this.$t("admin.push_notifications.no_schedule_date_specified_label");
            }

            return parametersString;
        },

        pushNotificationLastUpdatedOn(pushNotification) {
            if (pushNotification.lastUpdate) {
                return moment(new Date(pushNotification.lastUpdate)).format("YYYY-MM-DD hh:mm");
            } else {
                return this.$t("admin.push_notifications.not_available_label");
            }
        },

        handleNewPushNotificationClicked() {
            this.editedPushNotification = new PushNotification();
            this.editedPushNotification.active = true;
            this.editedPushNotification.mapIds = {};
            this.editedPushNotification.title = {
                en: null,
                fr: null
            }
            this.editedPushNotification.message = {
                en: null,
                fr: null
            }
            this.editedPushNotification.mapIds[this.mapId] = true;
        },

        handleEditPushNotificationClicked(pushNotification) {
            this.editedPushNotification = new PushNotification(JSON.parse(JSON.stringify(pushNotification)));
            if (!this.editedPushNotification.title) {
                this.editedPushNotification.title = {
                    en: null,
                    fr: null
                }
            }

            if (!this.editedPushNotification.message) {
                this.editedPushNotification.message = {
                    en: null,
                    fr: null
                }
            }
        },

        handleScheduleButtonClicked(pushNotification) {
            pushNotification.status = "to_schedule";
            this.savePushNotification(pushNotification);
        },

        handleMarkAsDraftButtonClicked(pushNotification) {
            pushNotification.status = "draft";
            this.savePushNotification(pushNotification);
        },

        handleDeletePushNotificationClicked(pushNotification) {
            this.pushNotificationToDelete = pushNotification;
            this.$refs.confirmDeleteAlert.show();
        },

        handleSendTestButtonClicked(pushNotification) {
            this.pushNotificationToSendTest = pushNotification;
            this.$refs.confirmSendTestAlert.show();
        },

        handleSendNowButtonClicked(pushNotification) {
            this.pushNotificationToSendNow = pushNotification;
            this.$refs.confirmSendNowAlert.show();
        },

        handleDeletePushNotificationConfirmed() {
            if (this.pushNotificationToDelete) {
                this.deletePushNotification(this.pushNotificationToDelete);
            }
        },

        handleSendTestPushNotificationConfirmed() {
            this.savePushNotification(this.pushNotificationToSendTest, true, false);
        },

        handleSendNowPushNotificationConfirmed() {
            this.savePushNotification(this.pushNotificationToSendNow, false, true);
        },


        handleCloseEditedPushNotificationClicked() {
            this.editedPushNotification = null;
        },

        handleSendTestEditedPushNotificationClicked() {
            this.handleSendTestButtonClicked(this.editedPushNotification);
        },

        handleSaveAsDraftEditedPushNotificationClicked() {
            this.editedPushNotification.status = "draft";
            this.savePushNotification(this.editedPushNotification);
        },

        handleSaveNowEditedPushNotificationClicked() {
            this.handleSendNowButtonClicked(this.editedPushNotification);
        },

        handleSaveAndScheduleEditedPushNotificationClicked() {
            this.editedPushNotification.status = "to_schedule";
            this.savePushNotification(this.editedPushNotification);
        }
    },

    mounted() {
        this.editionModal = new this.bootstrap.Modal(document.getElementById('editPushNotificationModal'));

        this.loadPushNotifications();
    }
}
</script>

<style scoped>
.push-notifications-container {
    background-color: #ffffff;
    margin: 0 auto;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
}

.push-notifications-list-container {
    width: 100%;
    height: 100%;
    overflow: scroll;
}

.push-notifications-list {
    list-style-type: none;
    padding: 0px;
}

.empty-list {
    color: #777777;
    font-size: 36px;
    font-weight: bold;
    margin-top: 64px;
    text-align: center;
}

.header {
    border-bottom: 1px solid #999999;
    font-weight: bold;
    margin-top: 16px;
}

.scrolling-area {
    width: 100%;
    height: 100%;
}

.push-notification-container {
    display: grid;
    grid-template-columns: auto 150px 430px 280px;
    grid-template-rows: auto auto auto auto;
    grid-template-areas: "title status actions lastupdatedon" "message . . ." "parameters parameters parameters parameters" "separator separator separator separator"
}

.push-notification-badges {
    grid-area: badges;
}

.push-notification-title {
    grid-area: title;
    font-weight: bold;
}

.push-notification-message {
    grid-area: message;
    color: #555555;
    white-space: pre-line;
}

.push-notification-status {
    grid-area: status;
}

.psuh-notification-last-updated-on {
    grid-area: lastupdatedon;
}

.push-notification-parameters {
    grid-area: parameters;
    color: #555555;
    font-size: 12px;
}

.push-notification-actions {
    grid-area: actions;
}

.push-notification-actions button {
    margin: 0px 4px 8px 0px;
}

.push-notification-container hr {
    grid-area: separator;
}

.scheduled-date-input {
    display: inline;
    margin-left: 8px;
    width: auto;
}
</style>
